export default __webpack_public_path__ + "static/blobs-5-864251ec42e776e2f591c408fcb5f64e.gif";